<template>
  <section>
    <!--
    <img v-if="$store.state.printing" :src="imageUrl" :alt="altText" width="93%" height="93%">
    -->
    <!--
    <img v-if="$store.state.printing" :src="imageUrl" :alt="altText"
      :width="imgElmWidth" :height="imgElmHeight">
    -->
    <img v-if="$store.state.printing" :src="imageUrl" :alt="altText"
      class="A4">
    <div v-else class="A4">
    <!--
    <div v-show="!$store.state.printing" class="A4">
    -->
      <ImageCanvas id="image-viewer"
        width="100%" height="100%"
        :canvasId="canvasId"
        :imageUrl="imageUrl"
        :imageScale="imageScale"
        :mouseClick="onImageClick"
        :enableWheel="enableWheel"
        @loaded="imageLoaded"
        @scaleChanged="imageScaleChanged"
        @imgMoved="imageMoved"
        v-if="useCanvas"
      />
      <ImageViewer id="image-viewer" :imageUrl="imageUrl"
        :scaleSize="scaleSizeReset"
        :mouseClick="onImageClick"
        @updateScaleSize="scaleSize = $event"
        @imgMoved="imageMoved" @imgLoaded="imageLoaded" @mouseMove="mouseMove"
        width="93%"
        v-else
      />
    </div>
  </section>
</template>

<script>
import ImageViewer from '../ImageViewer.vue'
//import { dbglog, imgUrl } from '../../common/utils'
import ImageCanvas from '../ImageCanvas.vue';

export default {
  components: {
    ImageViewer,
    ImageCanvas,
  },
  data() {
    return {
      useCanvas: true,
      imageScale: 0.85,  // ImageCanvasに渡す画像拡大率（画面横幅いっぱいを1とする）
      imageWidth: 0,  // オリジナル画像の幅
      imageHeight: 0, // オリジナル画像の高さ
      imgElmWidth: '87%',
      imgElmHeight: '87%',
      imgX: 0,        // ImageViewerのimg要素左位置
      imgY: 0,        // ImageViewerのimg要素上位置
      cursorX: 0,     // ImageViewer画像上のマウスカーソルX座標
      cursorY: 0,     // ImageViewer画像上のマウスカーソYX座標
      viewerRatio: 1, // 部分拡大窓の拡大率
      zoomScale: 1,   // ZoomImageViewerに渡すスケール値
      zoomCenterX: 0, // ZoomImageViewerに渡す画像中心X座標
      zoomCenterY: 0, // ZoomImageViewerに渡す画像中心Y座標
    }
  },
  props: {
    ukeNo: {
      type: String,
      //required: true,
      default: '',
    },
    pageNo: {
      type: Number,
      default: 1,
    },
    fileName: {
      type: String,
      default: '',
    },
    fileUrl: {
      type: String,
      default: '',
    },
    // test
    scaleSize: {
      type: Number,
      default: 1,
    },
    enableWheel: {
      type: Boolean,
      default: true,
    },
    canvasId: {
      type: String,
      default: 'kosaku-img-canvas',
    }
  },
  mounted() {
    //console.log(this.imageUrl);
  },
  computed: {
    imageUrl() {
      return this.fileUrl;
    },
    altText() {
      return this.imageUrl;
    },
    scaleSizeReset() {
      return this.scaleSize;
    },
  },
  methods: {
    zoomIn () {
      if(this.scaleSize < 10){
        this.scaleSize += 1;
      }
    },
    zoomOut () {
      if(this.scaleSize > 1){
        this.scaleSize -= 1;
      }
    },
    imageLoaded(param) {
      if (param) {
        if (this.useCanvas) {
          this.image = param;
          this.imageWidth = param.width;
          this.imageHeight = param.height;
          this.imageScale = 1;
        }
        else {
          this.imageWidth = param.srcw;
          this.imageHeight = param.srch;
        }
      }
    },
    imageMoved(param) {
      this.imgX = param.x;
      this.imgY = param.y;
    },
    imageScaleChanged(scale) {
      this.imageScale = scale;
    },
    mouseMove(param) {
      this.cursorX = param.x;
      this.cursorY = param.y;
      if (this.zoomOnMove) {
        this.zoomCenterX = param.x;
        this.zoomCenterY = param.y;
      }
    },
    onImageClick(x, y) {
      this.zoomCenterX = x;
      this.zoomCenterY = y;
    },
  },
}
</script>

<style lang="scss" scoped>
#image-viewer {
  margin-left: 0mm; 
}
.A4 {
  margin-left: 10mm;
  //width: 210mm;
  //height: 296mm;
  width: calc(210mm - 22mm - 20mm);
  height: calc(296mm - 26mm - 20mm);
  background-color: white;
}
</style>